import { useQuery } from '@tanstack/react-query';
import { api, GrTimePlayedAggregates } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTimePlayedReturn {
  data: GrTimePlayedAggregates | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useTimePlayed(): UseTimePlayedReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.timePlayed(),
    queryFn: () => api.getGameRewardsTimePlayed(),
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error:
      error instanceof Error ? error.message : isError ? 'Failed to load time played data' : null,
    refresh: () => {
      refetch();
    },
  };
}
